import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Image as CloudinaryImage, Transformation } from 'cloudinary-react';
import Image from '../Image/Image.jsx';
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { uploadVideo } from '../../utils/videoUpload';
import { uploadFile } from '../../utils/fileUpload';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

class ImageCropModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: null,
            crop: {
                unit: '%',
                width: 30,
                aspect: 16 / 16,
            },
            fileName: '',
            file: null,
            mimeType: '',
        }
    }
    componentDidMount() { }
    componentWillMount() { }

    updateProfilePic = async e => {
        let { data } = this.props;
        if (e.target.files.length) {
            this.props.modalClose();
            this.props.showLoader();
            let imageID = await uploadFile(e.target.files[0]);
            this.props.updateProfileMedia({ contestName: data.contestName, profilePic: imageID.public_id })
        }
    }
    updateIntroVideo = async e => {
        let { data } = this.props;
        if (e.target.files.length && e.target.files[0].type.includes('video')) {
            this.props.modalClose();
            this.props.showLoader('Please wait we are uploading your video...');
            await uploadVideo(e.target.files[0], (err, data1) => {
                if (!err) {
                    this.props.updateProfileMedia({ contestName: data.contestName, introductionVideo: [data1.Location] })
                }
            });
        }

    }

    onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            this.setState({ fileName: e.target.files[0].name, mimeType: e.target.files[0].type })
          const reader = new FileReader();
          reader.addEventListener('load', () =>
            this.setState({ src: reader.result })
          );
          reader.readAsDataURL(e.target.files[0]);
        }
      };
    
      // If you setState the crop in here you should return false.
      onImageLoaded = image => {
        this.imageRef = image;
      };
    
      onCropComplete = crop => {
        this.makeClientCrop(crop);
      };
    
      onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
      };

    async makeClientCrop(crop) {
        // const { fileName } = this.state;
        const { fileName } = this.props.data;
        if (this.imageRef && crop.width && crop.height) {
          const croppedImageUrl = await this.getCroppedImg(
            this.imageRef,
            crop,
            'newFile.jpeg'
          );
          this.setState({ croppedImageUrl });
          this.blobToFile(croppedImageUrl, fileName);
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');
    
        ctx.drawImage(
          image,
          crop.x * scaleX,
          crop.y * scaleY,
          crop.width * scaleX,
          crop.height * scaleY,
          0,
          0,
          crop.width,
          crop.height
        );
    
        return canvas.toDataURL("image/jpg");
        // return new Promise((resolve, reject) => {
        //   canvas.toBlob(blob => {
        //     if (!blob) {
        //       //reject(new Error('Canvas is empty'));
        //       console.error('Canvas is empty');
        //       return;
        //     }
        //     blob.name = fileName;
        //     window.URL.revokeObjectURL(this.fileUrl);
        //     this.fileUrl = window.URL.createObjectURL(blob);
        //     resolve(this.fileUrl);
        //   }, 'image/jpeg');
        // //   canvas.toBlob(blob => {
        // //     if (!blob) {
        // //       //reject(new Error('Canvas is empty'));
        // //       console.error('Canvas is empty');
        // //       return;
        // //     }
        // //     blob.name = fileName;
        // //     window.URL.revokeObjectURL(this.fileUrl);
        // //     this.fileUrl = window.URL.createObjectURL(blob);
        // //     resolve(this.fileUrl);
        // //   }, 'image/jpeg');
        // });
      }

      blobToFile = async (theBlob, fileName, mimeType) => {
        // var b = theBlob;
        // //A Blob() is almost a File() - it's just missing the two properties below which we will add
        // // b.lastModifiedDate = new Date();
        // b.name = fileName;
    
        //Cast to a File() type
        // return new File([theBlob], fileName);



        // let test = (fetch(theBlob)
        // .then(function(res){return res.arrayBuffer();})
        // .then(function(buf){return new File([buf], fileName,{type:mimeType});}));
        // let data = await Promise.all([test]);
        // return data[0];


        var arr = theBlob.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        try {
            let test = await Promise.all([new File([u8arr], fileName, {type:mime})]);
            this.setState({file: test[0]});
        } catch(e) {
            let test = await Promise.all([new Blob([u8arr], fileName, {type:mime})]);
            this.setState({file: test[0]});
        }
        return null;
        
    }



    render() {
        let { data } = this.props;
        let { src } = data;
        const { crop, croppedImageUrl, fileName, file } = this.state;
        // this.props.open
        return (
            <div className="modal" id="ticketmodal" tabIndex="-1" role="dialog" aria-hidden="true" style={this.props.open ? { display: 'block' } : {}} onClick={this.props.modalClose}>
                <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                    <div className="modal-content animated bounceIn" onClick={e => e.stopPropagation()}>
                        <div className="ticket-modal">
                            <React.Fragment>
                                <div className="reportcontent">
                                    <p className="mb-0 cotmed">Profile media</p>
                                </div>
                                <div className="modalmaincontent reportmaincontent pt-0">
                                    {/* <div>
                                        <input type="file" accept="image/*" onChange={this.onSelectFile} />
                                    </div> */}
                                    {src != undefined && src ? (
                                    <ReactCrop
                                        src={src}
                                        crop={crop}
                                        ruleOfThirds
                                        onImageLoaded={this.onImageLoaded}
                                        onComplete={this.onCropComplete}
                                        onChange={this.onCropChange}
                                    />
                                    ) : null}
                                    {/* {croppedImageUrl && console.log("TCL: ImageCropModal -> render -> croppedImageUrl", croppedImageUrl)} */}
                                    {/* {croppedImageUrl && <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />} */}
                                    {/* {croppedImageUrl && file == null && } */}
                                    {/* {file && <img alt="Crop" style={{ width: '100%' }} src={(file)} />} */}
                                    {/* {file && console.log('FILE', file)} */}
                                    {data.saveClick != undefined && data.saveClick ? (
                                        <button className="btn btn-primary btn-block" onClick={()=>{
                                            data.saveClick(file);
                                            this.props.modalClose();
                                        }}>Save</button> 
                                    ): null}

                                </div>
                            </React.Fragment>
                            <div className="modalfooter pointer" onClick={this.props.modalClose}>
                                <a className="">Cancel</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ imageCropModal }) => {
    const { open, data } = imageCropModal;
    return { open, data };
};

const mapDispatchToProps = dispatch => ({
    modalClose: () => dispatch(actions.imageCropModalClose()),
    dispatch
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageCropModal);